import "./singleBookPending.scss";
import { useEffect } from "react";
import Single from "../single/Single";
import { useParams } from "react-router-dom";
import Navbar from "../../components/navbar/Navbar";

const SingleBookPending = () => {
  const { productId } = useParams();
  useEffect(() => {
    document.title = "Wishallbook";
  }, []);

  return (
    <div className="list">
    <Navbar/>
  
      <div className="listContainer">
        <Single type="pending" bookID={productId} />
      </div>
    </div>
  );
};

export default SingleBookPending;
